import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
function App() {
  return (
      <div>
        <Navbar />
        <Footer />
      </div>
  );
}

export default App;
